<template>
  <div class="page">
    <v-chart ref="lineChartObject" :autoresize="true" class="chart" :option="lineOption"
      :update-options="{ notMerge: true }" />
  </div>
</template>
<script>
export default {
  name: "LineChart2",
  provide: {
    // [THEME_KEY]: "dark"
  },
  props: {
    title: {
      type: String,
    },
    legend: {
      type: Array
    },
    xAxis: {
      type: Array
    },
    series: {
      type: Array
    },
    yMax: {
      type: Number
    },
    yMin: {
      type: Number
    }
  },
  watch: {
    title: {
      handler: function (newVal, oldVal) {
        this.lineOption = this.getLinetOptions();
      }
    },
    series: {
      handler: function (newVal, oldVal) {
        if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
          this.lineOption = this.getLinetOptions();
        }
      }
    }
  },
  data() {
    return {
      lineOption: {
        title: {
          left: "center",
          text: this.title,
        },
        tooltip: {
          trigger: "axis",
        },
        toolbox: {
          show: true,
          feature: {
            dataZoom: { show: true, yAxisIndex: false, },
            dataView: { show: true, readOnly: false, },
            magicType: { show: true, type: ["line", "bar"], },
            restore: { show: true, },
            saveAsImage: { show: true, },
          },
        },
        legend: {
          show: false,
          bottom: "0",
          data: this.legend,
        },
        dataZoom: [{
          type: "inside",
          start: 0,
          end: 100
        }, {
          start: 0,
          end: 100
        }],
        grid: {
          left: "3%",
          right: "4%",
          bottom: "12%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.xAxis
        },
        yAxis: {
          type: "value",
          max: this.yMax,
          min: this.yMin
        },
        series: this.series,
      },
    };
  },
  methods: {
    getLinetOptions() {
      this.lineOption = {
        title: {
          left: "center",
          text: this.title,
        },
        tooltip: {
          trigger: "axis",
        },
        toolbox: {
          show: true,
          feature: {
            dataZoom: { show: true, yAxisIndex: false, },
            dataView: { show: true, readOnly: false, },
            magicType: { show: true, type: ["line", "bar"], },
            restore: { show: true, },
            saveAsImage: { show: true, },
          },
        },
        legend: {
          show: false,
          bottom: "0",
          data: this.legend,
        },
        dataZoom: [{
          type: "inside",
          start: 0,
          end: 100
        }, {
          start: 0,
          end: 100
        }],
        grid: {
          left: "3%",
          right: "4%",
          bottom: "12%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.xAxis
        },
        yAxis: {
          type: "value",
          max: this.yMax,
          min: this.yMin
        },
        series: this.series,
      };
      return this.lineOption;
    }
  },
  mounted() { },
};
</script>
<style scoped>
.chart {
  height: 260px;
}
</style>
